import { render, staticRenderFns } from "./ObjectDashboard.vue?vue&type=template&id=eeac54d4&scoped=true"
import script from "./ObjectDashboard.vue?vue&type=script&lang=ts"
export * from "./ObjectDashboard.vue?vue&type=script&lang=ts"
import style0 from "./ObjectDashboard.vue?vue&type=style&index=0&id=eeac54d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eeac54d4",
  null
  
)

export default component.exports